// import external libraries
import { useTranslation } from 'react-i18next';

// import components
import { Typography } from '@mui/material';

// import utils
import { getIconColor, getIconType } from 'components/mrp/mrp.utils';

// import styles
import {
  HeadingIcon,
  HeadingRow,
  HeadingRule
} from './BacklogFilterSectionHeading.styles';

// import types
import type { BacklogFilterSectionHeadingProps } from './BacklogFilterSectionHeading.types';

/**
 * Names the entity the fields under it filter on: its symbol, its name, and a rule out to the edge.
 *
 * The popover shows the filters of the entity on screen, and above them the activity filter, which narrows
 * every view. Without this heading both tiers read as one list of fields and the planner has to infer from
 * the labels which of them only applies to patients — the symbol and the rule say so instead. It is the same
 * symbol and colour the toolbar's entity buttons and the grid's rows carry, so the section is recognisably
 * the view they picked.
 */
const BacklogFilterSectionHeading = ({
  entityType
}: BacklogFilterSectionHeadingProps) => {
  'use memo';

  const { t } = useTranslation('common');

  return (
    <HeadingRow>
      <HeadingIcon
        type={getIconType(entityType)}
        entityColor={getIconColor(entityType)}
      />
      <Typography variant="subtitle2" noWrap>
        {t(`mrp.entityTypeMap.${entityType}.plural`)}
      </Typography>
      <HeadingRule />
    </HeadingRow>
  );
};

export default BacklogFilterSectionHeading;
